/* eslint-disable import/no-cycle */
import React, { FC, useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IRootReducer } from 'src/store/reducers';

import Tab from '@material-ui/core/Tab';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
    editShiftSelector,
    formSelector,
    selectedSingleShiftSelector,
    shiftsSelector,
    tableSelector,
    uiSelector,
} from 'src/store/selectores/passengerShiftsSelectores';
import moment, { Moment } from 'moment';

import {
    onFormShowChange,
    removePassengersShift,
    setEditShift,
    setSelectedAllPassengers,
} from 'src/store/actions/PassengersShiftActionType';
import {
    IEditShift,
    IPassengerShifts,
    IPassengerShiftUpdate,
    OrderAddresses,
    SetPassengersResponseCodes,
} from 'src/types/manualOrders/api.types';
import { loginSelector } from 'src/store/selectores/loginSelectors';
import { delPassngerShifts, getPassngerShifts, setPassengersOrders } from 'src/api/manualOrderApi/manualOrderApi';
import Alert from 'src/components/commons/Alert/Alert';
import useStateReset from 'src/hooks/useStateReset';
import { useIsFirstRender } from 'src/hooks/useIsFirstRender';
import { DISPLAY_UI, SHORT } from 'src/constants/dates';
import LoadingButton from '@mui/lab/LoadingButton';
import { useAppDispatch, useRootAppSelector } from 'src/store/hooks';
import {
    displayPlacementFormAction,
    passengersOrdersCountPerDateSelector,
    screenClientCodeSelector,
    selectedAddressForPlacementSelector,
    selectedPassengersSelector,
    setPlacementAddressAction,
    setSelectedPassengersAction,
} from 'src/store/slices/manualOrders/manualOrdersSlice';
import { PASSENGER_ID_INDEX } from 'src/store/slices/manualOrders/helpers';
import { useErrorMessageDispatcher } from 'src/hooks/useErrorHandler';
import { manualOrdersApiConsts } from 'src/api/manualOrderApi/constants';
import { findNextIdByCellIndex } from '@progress/kendo-react-data-tools/dist/npm/navigation/utils';
import { AxiosResponse } from 'axios';
import { Slide } from '@mui/material';
import i18n from 'src/i18n';
import { manualOrdersConstants as constants } from 'src/constants/byScreen/manualOrders/components';
import { ManualPlacement as ManualPlacementObj } from 'src/screens/ManualOrder/utilis';
import * as Styles from './PlacemenTransportation.Style';
import Regularshiftplacement from './components/Regularshiftplacement/Regularshiftplacement';
import { initialAutoOrderState, initialManualOrderState, initialState } from './context';
import ManualPlacement from './components/Manualplacement/Manualplacement';
import MoreDays from './components/Moredays/MoreDays';
import {
    deepClone,
    formatDateToString,
    formatDateToString as stringifyDate,
} from '../../../../utilis/utilis';
import { RELATIVE } from '../../../../constants/dates';
import OrderDatesDetails from './components/OrderDatesDetails/index';
import { buildPlacementShiftObj, findFirstNonPastDate, getUpdatedOrdersCount } from '../../utilis';
import usePlacement from '../../hook/usePlacement';
import { ShiftType } from '../../types';
import { useIsSubmitDisabled } from './hooks/useIsSubmitDisabled';
import useDisableDelay from '../../../../hooks/useDelayV2';
import { Order, placementTransportationHooks, useOnAddDayUtils } from './hooks/common';
import useDatesStatus from './hooks/useOrderDaysData';
import { PASSENGER_LOCATION_INDEX } from '../../../../store/slices/manualOrders/helpers';
import { manualOrdersCommonHooks } from '../../hook/manualOrdersHooks.common';
import { buildAddresseesParams } from './utilis';
import PlacementAddressSelection from './components/PlacementAddressSelection/index.PlacementAddressSelection';
import PassengersAddressesPicker from './components/PassengersAddressesMatrix/picker.PassengersAddressesMatrix';
import SaveProgress from './components/SaveProgress/SaveProgress';
import { SaveProgressState } from './components/SaveProgress/types.SaveProgress';
import { StepNumber, StepTitle } from './components/StepNumber/styles.StepNumber';
import editTransaction, { EditOutcome, SavedOrder } from './editTransaction';
import editData from './editData';
import * as PickerStyles from './components/PassengersAddressesMatrix/styles.PassengersAddressesPicker';
import orderAddressHelpers, {
    NO_ORDER_ADDRESSES,
} from './components/PlacementAddressSelection/orderAddress.PlacementAddressSelection';
import passengersAddressesHelpers, {
    AddressChoices,
    GroupOutcome,
} from './components/PassengersAddressesMatrix/helpers.PassengersAddressesMatrix';

const SUCCESS = 0;

type SetOrdersData = {
    message: IPassengerShiftUpdate[];
    response: SetPassengersResponseCodes;
};

/** One ws_MyWayStudio_Set_Passengers_Orders call: passengers that share the same pickup and drop address */
interface OrderGroup {
    passIds: string[];
    addressParams: OrderAddresses;
}

export enum TABS {
    AUTO = 0,
    MANUAL = 1,
}

const ERROR_STINGS = {
    1: i18n.t('invalidToken'),
    2: i18n.t('dateOrTimeBeforeCurrent'),
    3: i18n.t('invalidDepartment'),
    4: i18n.t('sqlError'),
    5: i18n.t('blockedPickupUp'),
    6: i18n.t('blockedDrop'),
    7: i18n.t('blockedForToday'),
    8: i18n.t('blockedForTomorrow'),
    9: i18n.t('blockedForWeekend'),
    10: i18n.t('blockedForSunday'),
    11: i18n.t('clientNotFound'),
};

interface Props {
    date: Date | Moment;
    handleClose: () => void;
    editShift?: IEditShift;
    selectedClinet: any;
}
const PlacemenTransportation: FC<Props> = ({
    date,
    handleClose,
    editShift,
    selectedClinet: selectedClient,
}: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    placementTransportationHooks.useDataReFetchingForPlacement();

    const [dispatchErrorMsg] = useErrorMessageDispatcher();

    const { onClickClose: onClikClose } = manualOrdersCommonHooks.usePlacementFormUtils();

    // & Contexts
    const { placment: placement, setPlacment, resetToInitialShiftData } = usePlacement();

    // & Local states
    const [selctedTab, setSelectedTab] = useState<TABS>(TABS.AUTO);

    const [errorState, setErrorState] = useState<{
        isShow: boolean;
        message: string;
        severity: 'error' | 'success';
    }>({
        isShow: false,
        message: '',
        severity: 'error',
    });

    // & Selectors
    const selectedAddresses = useRootAppSelector(selectedAddressForPlacementSelector);

    const relativeDateOfCurrShiftCell: string = useSelector((state: IRootReducer) => {
        if (selectedSingleShiftSelector(state)?.relativeDate) {
            return moment(selectedSingleShiftSelector(state)?.relativeDate || '', DISPLAY_UI).format(
                RELATIVE
            );
        }
        if (editShiftSelector(state)?.date) {
            return stringifyDate(editShiftSelector(state)?.date || '', RELATIVE);
        }
        return findFirstNonPastDate(moment(tableSelector(state).dateRange.startingDate, SHORT));
    });
    const { selectedFcAccount, token } = useSelector((state: IRootReducer) => loginSelector(state));
    const passengers = useSelector((state: IRootReducer) => state.passengersShiftReudcer.passengers);
    // -- Shake logic
    const blockedTableClickCount: number = useSelector(
        (state: IRootReducer) => state.passengersShiftReudcer.ui.form.blockedTableClickCount
    );
    const countWithDelay = useStateReset(blockedTableClickCount, 0, 100);

    const editShiftRedux = useSelector((state: IRootReducer) => editShiftSelector(state));
    const shifts = useSelector((state: IRootReducer) => shiftsSelector(state));
    const selectedManualShift = useSelector(
        (state: IRootReducer) => uiSelector(state).form.selectedManualShift
    );
    const clientCode = useRootAppSelector(screenClientCodeSelector);
    const editingShift = useSelector((state: IRootReducer) => state.passengersShiftReudcer.editShift);
    const selectedPassengers = useRootAppSelector(selectedPassengersSelector);

    placementTransportationHooks.useEditedShiftAsInitialManualOrderData({
        editShift,
        selectedTab: selctedTab,
    });

    useEffect(() => {
        // Reset selected address on state to avoid display bad addresses
        dispatch(setPlacementAddressAction(null));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, JSON.stringify(selectedPassengers)]);

    // & Global variables
    const selectedPassengersFullData = useMemo(() => {
        return selectedPassengers.map(([, index]) => passengers[index]);
    }, [passengers, selectedPassengers]);

    // -- Editing an order: the pickup / drop addresses saved on it (D-058), for the address drop-downs
    const editedOrderAddresses = useMemo(() => {
        if (!editShiftRedux) return NO_ORDER_ADDRESSES;
        return orderAddressHelpers.getOrderAddresses({
            passenger: passengers.find((p: IPassengerShifts) => p?.passId === editShiftRedux.passId),
            date: editShiftRedux.date,
            orderCodes: editShiftRedux.codes,
            pickupTime: editShiftRedux.pickupTime,
            dropTime: editShiftRedux.dropTime,
        });
    }, [editShiftRedux, passengers]);

    // -- Order days: one source for the date picker and the days grid
    const datesForOrders = useDatesStatus(selectedPassengersFullData);
    const addDayUtils = useOnAddDayUtils();
    const { setSelectedDaysCounter } = addDayUtils;

    /** The days of a "from – to" range replace the selection, as if each was chosen in the grid */
    const onPickDates = useCallback(
        (days: Moment[]) => {
            setPlacment((pre) => ({ ...pre, dates: days.map((day) => ({ relativeDate: day.format(RELATIVE) })) }));
            setSelectedDaysCounter(days.length);
        },
        [setPlacment, setSelectedDaysCounter]
    );

    // -- Address per passenger, when several passengers are placed together
    const [addressChoices, setAddressChoices] = useState<AddressChoices>({});
    const isMultiPassengers = passengersAddressesHelpers.shouldUseMatrix(
        selectedPassengers.map((p) => p[PASSENGER_ID_INDEX]),
        addressChoices
    );
    // Orders saved by a partial save; closing must then refresh the table
    const [hasPartialSave, setHasPartialSave] = useState(false);
    // A save can outlive the 3 s button delay when it sends several groups
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [saveProgress, setSaveProgress] = useState<SaveProgressState | null>(null);
    // Sides (pickup / drop) already saved per passenger, so a retry after a partial save does not resend them
    const savedSidesRef = useRef(new Set<string>());

    const selectedPassengersForAddresses = useMemo(
        () =>
            selectedPassengers.map(([passId, index]) => ({
                passId,
                fullName: passengers[index]?.fullName || passId,
                departmentName: passengers[index]?.departmentName,
            })),
        [passengers, selectedPassengers]
    );

    useEffect(() => {
        // Forget the choices of passengers that are no longer selected
        const selectedIds = selectedPassengers.map((p) => p[PASSENGER_ID_INDEX]);
        setAddressChoices((prev) => passengersAddressesHelpers.pruneChoices(prev, selectedIds));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(selectedPassengers)]);

    /**
     * The set-orders calls to make. One passenger, or several with no address chosen, is one call as before;
     * several passengers with different addresses are one call per group of identical addresses.
     */
    const getOrderGroups = (): OrderGroup[] => {
        const passIds = selectedPassengers.map((p) => p[PASSENGER_ID_INDEX]);

        if (!isMultiPassengers) {
            return [{ passIds, addressParams: buildAddresseesParams(selectedAddresses) }];
        }

        return passengersAddressesHelpers
            .groupPassengersByAddresses(passIds, addressChoices)
            .map((group) => ({ passIds: group.passIds, addressParams: buildAddresseesParams(group.addresses) }));
    };

    const getPassengersNames = (passIds: string[]) =>
        selectedPassengersForAddresses
            .filter((p) => passIds.includes(p.passId))
            .map((p) => p.fullName)
            .join(', ');

    // & Event handlers

    const handleChange = (e: any, newValue: number) => {
        setSelectedTab(newValue);
        resetToInitialShiftData(selctedTab === 0 ? ShiftType.Auto : ShiftType.Manual, true);
    };

    const handleResponse = (data: {
        message: IPassengerShiftUpdate[];
        response: SetPassengersResponseCodes;
    }) => {
        try {
            if (data.response === SUCCESS) {
                setErrorState({
                    message: t('successOrder'),
                    isShow: true,
                    severity: 'success',
                });

                setTimeout(() => {
                    dispatch(
                        setSelectedAllPassengers({
                            isSelected: false,
                            passengers: [],
                        })
                    );
                    onClikClose(handleClose);
                    dispatch(setEditShift(null));
                }, 1);
            } else {
                setErrorState({
                    message:
                        String(data.response) === '99'
                            ? JSON.stringify(data.message)
                            : ERROR_STINGS[data.response],
                    isShow: true,
                    severity: 'error',
                });
            }
        } catch (error) {
            // logToLocalStorage(error, 'thrown error');
            setErrorState({
                message: t('genralError'),
                isShow: true,
                severity: 'error',
            });
        }
    };

    const [tempDisabled, setTempDisabled] = useDisableDelay(3000);

    const changedOrderData = placementTransportationHooks.useChangedOrderData({
        isAutoOrder: selctedTab === TABS.AUTO,
        placement,
    });

    const currOrders: Order = useMemo(() => changedOrderData.getCurrOrder(), [changedOrderData.getCurrOrder]);

    const getSetOrdersErrorMessage = (data: { message: unknown; response: SetPassengersResponseCodes } | null) => {
        if (!data) return t('genralError');
        if (String(data.response) === '99') return JSON.stringify(data.message);
        return ERROR_STINGS[data.response] || t('genralError');
    };

    /**
     * Reports the result of several set-orders calls. All saved: the usual success.
     * Otherwise the form stays open with only the passengers that were not saved selected.
     */
    const handleGroupOutcomes = (outcomes: GroupOutcome[]) => {
        const { allSaved, failed, savedIds, failedIds } = passengersAddressesHelpers.summarizeOutcomes(outcomes);

        if (allSaved) {
            handleResponse({ response: SUCCESS, message: [] as IPassengerShiftUpdate[] } as SetOrdersData);
            return;
        }

        setTempDisabled(false);
        if (savedIds.length) setHasPartialSave(true);
        setErrorState({
            message: t('multiAddressPartialSave', {
                saved: getPassengersNames(savedIds) || '-',
                failed: failed.map((f) => `${getPassengersNames(f.passIds)} (${f.error})`).join('; '),
            }),
            isShow: true,
            severity: 'error',
        });

        if (savedIds.length) dispatch(setSelectedPassengersAction(failedIds));
    };

    // The "saving passenger X of Y" window: only when several passengers are saved together
    const reportGroupsProgress = (done: number, current: number) =>
        setSaveProgress((prev) => (prev ? { ...prev, done, current, isSingleCall: false } : prev));
    const showSingleCallProgress = (group: OrderGroup) =>
        setSaveProgress((prev) => (prev ? { ...prev, current: group.passIds.length, isSingleCall: true } : prev));

    // The set-orders call of the regular-shift tab for one group of passengers. At component level (it was inside
    // onSubmitAuto) so that the edit transaction sends exactly the same call, one passenger at a time.
    const sendAutoOrders = (group: OrderGroup) => {
        const { proxyUrl, dbUrl = '' } = selectedFcAccount || {};
        const { pickupTime, dropTime, shiftId } = placement.autoOrder;

        return setPassengersOrders({
            proxyUrl,
            dbUrl,
            jsonData: {
                token,
                passengers: group.passIds.join(','),
                pickupTime,
                shiftId,
                dropTime,
                dates: placement.dates,
            },
            ...group.addressParams,
            clientCode: selectedClient.value,
        });
    };

    // Which sides the flexible tab sends - one source for the save below and for the slots the edit transaction
    // expects the save to fill
    const manualSidesToSend = () => {
        const { pickupShiftId } = placement.manualOrder.pickup;
        const { dropTime, dropShiftId } = placement.manualOrder.drop;

        return {
            // If selected pickup AND [ deleted pickup OR not had pickup to delete ]
            pickup: !!(
                currOrders.pickup.time &&
                (changedOrderData.deletedOrder?.pickupTime || !editShift?.pickupTime) &&
                pickupShiftId &&
                pickupShiftId !== String(constants.FILLER_ID)
            ),
            // If selected drop AND [ deleted drop OR not had drop to delete ]
            drop: !!(
                currOrders.drop.time &&
                (changedOrderData.deletedOrder?.dropTime || !editShift?.dropTime) &&
                dropTime &&
                dropShiftId !== String(constants.FILLER_ID)
            ),
        };
    };

    // The pickup and the drop calls of the flexible tab for one group of passengers that share the same
    // addresses. At component level (it was inside onSubmitManual) for the same reason as sendAutoOrders.
    const sendManualOrders = async (
        group: OrderGroup,
        skip: { pickup: boolean; drop: boolean } = { pickup: false, drop: false }
    ) => {
        const sides = manualSidesToSend();
        const { proxyUrl, dbUrl = '' } = selectedFcAccount || {};

        const basePayload = {
            proxyUrl,
            dbUrl,
            jsonData: {
                token,
                passengers: group.passIds.join(','),
                dates: placement.dates,
            },
        };

        const groupResponses: {
            pickup: null | AxiosResponse<SetOrdersData>;
            drop: null | AxiosResponse<SetOrdersData>;
        } = {
            pickup: null,
            drop: null,
        };

        let madeRequests = false;

        if (!skip.pickup && sides.pickup) {
            madeRequests = true;
            groupResponses.pickup = await setPassengersOrders({
                ...basePayload,
                jsonData: {
                    ...basePayload.jsonData,
                    pickupTime: currOrders.pickup.time,
                    shiftId: currOrders.pickup.id,
                },
                ...group.addressParams,
                clientCode: selectedClient.value,
            });
        }

        if (!skip.drop && sides.drop) {
            madeRequests = true;
            groupResponses.drop = await setPassengersOrders({
                ...basePayload,
                jsonData: {
                    ...basePayload.jsonData,
                    dropTime: currOrders.drop.time,
                    shiftId: currOrders.drop.id,
                },
                ...group.addressParams,
                clientCode: selectedClient.value,
            });
        }

        return { groupResponses, madeRequests };
    };

    const onSubmitAuto = async () => {
        try {

            console.log('   onSubmitAuto ');

            setTempDisabled(true);

            // sendAutoOrders moved to component level, above

            const groups = getOrderGroups();

            // -- One group: today's flow
            if (groups.length === 1) {
                showSingleCallProgress(groups[0]);
                const res = await sendAutoOrders(groups[0]);
                handleResponse(res.data);
                return;
            }

            // -- Several groups: send them one after another and report which passengers were saved
            const outcomes = await passengersAddressesHelpers.sendGroupsInOrder(
                groups,
                async (group) => {
                    const res = await sendAutoOrders(group);
                    return +res.data.response === SUCCESS ? null : getSetOrdersErrorMessage(res.data);
                },
                t('genralError'),
                reportGroupsProgress
            );
            handleGroupOutcomes(outcomes);
        } catch (error) {
            console.error(error);
            setErrorState({
                message: t('genralError'),
                isShow: true,
                severity: 'error',
            });
        }
    };

    const onSubmitManual = async () => {
        try {
            console.log('    onSubmitManual   ');

            setTempDisabled(true);

            const { pickupShiftId } = placement.manualOrder.pickup;
            const { dropShiftId } = placement.manualOrder.drop;

            if (!pickupShiftId && !dropShiftId) return;

            // sendManualOrders moved to component level, above onSubmitAuto - the same calls, unchanged

            const groups = getOrderGroups();

            // -- Several groups: send them one after another and report which passengers were saved
            if (groups.length > 1) {
                const outcomes = await passengersAddressesHelpers.sendGroupsInOrder(
                    groups,
                    async (group) => {
                        const datesKey = JSON.stringify(placement.dates);
                        const times = { pickup: currOrders.pickup.time, drop: currOrders.drop.time };
                        const sides: ('pickup' | 'drop')[] = ['pickup', 'drop'];
                        const isSaved = (side: 'pickup' | 'drop') =>
                            passengersAddressesHelpers.isSideSavedForAll(
                                savedSidesRef.current,
                                group.passIds,
                                side,
                                times[side],
                                datesKey
                            );

                        const { groupResponses } = await sendManualOrders(group, {
                            pickup: isSaved('pickup'),
                            drop: isSaved('drop'),
                        });

                        // Remember each side that went through, and name the side that did not
                        const errors: string[] = [];
                        sides.forEach((side) => {
                            const res = groupResponses[side];
                            if (!res) return;
                            if (+res.data.response === SUCCESS) {
                                group.passIds.forEach((passId) =>
                                    savedSidesRef.current.add(
                                        passengersAddressesHelpers.savedSideKey(passId, side, times[side], datesKey)
                                    )
                                );
                            } else {
                                errors.push(`${t(side)}: ${getSetOrdersErrorMessage(res.data)}`);
                            }
                        });

                        return errors.length ? errors.join(', ') : null;
                    },
                    t('genralError'),
                    reportGroupsProgress
                );
                handleGroupOutcomes(outcomes);
                return;
            }

            // -- One group: today's flow
            showSingleCallProgress(groups[0]);
            const { groupResponses: responses, madeRequests: madeSetOrderRequests } = await sendManualOrders(
                groups[0]
            );

            const handleBadResponse = (data: {
                message: IPassengerShiftUpdate[] | string;
                response: SetPassengersResponseCodes;
            }) => {
                setTempDisabled(false);
                setErrorState({
                    message:
                        String(data.response) === '99'
                            ? JSON.stringify(data.message)
                            : ERROR_STINGS[data.response],
                    isShow: true,
                    severity: 'error',
                });
            };

            // -- If one of the calls failed, display an error,
            // -- otherwise handle both the responses
            if (responses.pickup && +responses.pickup.data.response !== SUCCESS) {
                handleBadResponse(responses.pickup.data);
                return;
            }
            if (responses.drop && +responses.drop.data.response !== SUCCESS) {
                handleBadResponse(responses.drop.data);
                return;
            }

            if (responses.pickup) handleResponse(responses.pickup.data);
            if (responses.drop) handleResponse(responses.drop.data);
            if (!madeSetOrderRequests) {
                const mockOkResponse = {
                    response: 0,
                    message: [] as any[],
                } as const;
                handleResponse(mockOkResponse);
            }
        } catch (error) {
            console.log(error);
            setErrorState({
                message: t('genralError'),
                isShow: true,
                severity: 'error',
            });
        }
    };

    // console.log({ deletedOrder: changedOrderData.deletedOrder });

    // & Editing a shift, for one passenger or for several: a client-side transaction (editTransaction.ts), which
    // reasons in slots (day, side, time) because the server skips a slot that already holds an order.

    const editDate = editingShift?.date || date;

    // The sides the edit replaces, by their times: deletedOrder's times are right for every kind of cell, while
    // its codes are taken by position and are wrong for a drop-only cell
    const replacedTimes = {
        pickupTime: changedOrderData.deletedOrder?.pickupTime || '',
        dropTime: changedOrderData.deletedOrder?.dropTime || '',
    };

    /** The slots the save writes: each saved day, each side it sends, at the new times */
    const editTargetSlots = () => {
        if (selctedTab === TABS.AUTO) {
            const { pickupTime, dropTime } = placement.autoOrder;
            return editData.targetSlots(placement.dates, { pickupTime, dropTime });
        }
        const sides = manualSidesToSend();
        return editData.targetSlots(placement.dates, {
            pickupTime: sides.pickup ? currOrders.pickup.time : '',
            dropTime: sides.drop ? currOrders.drop.time : '',
        });
    };

    /**
     * The addresses of one passenger's new orders. One passenger: the drop-downs, as always. Several: the
     * address chosen in the addresses window, else the address saved on the order being replaced - an edit
     * of the shift must not move a passenger to the default address unasked.
     */
    const editAddressParams = (passId: string) => {
        if (!isMultiPassengers) return buildAddresseesParams(selectedAddresses);

        const choice = addressChoices[passId] || { pickup: null, drop: null };
        const onOrder = orderAddressHelpers.getOrderAddresses({
            passenger: passengers.find((p: IPassengerShifts) => p?.passId === passId),
            date: editDate,
            // The clicked cell's codes for its passenger; the others' orders are found by the shift's times
            orderCodes: passId === editingShift?.passId ? editingShift.codes : [],
            pickupTime: editingShift?.pickupTime,
            dropTime: editingShift?.dropTime,
        });
        return buildAddresseesParams({
            pickup: (choice.pickup || onOrder.pickup) as Parameters<typeof buildAddresseesParams>[0]['pickup'],
            drop: (choice.drop || onOrder.drop) as Parameters<typeof buildAddresseesParams>[0]['drop'],
        });
    };

    const saveEditedPassenger = async (passId: string) => {
        const group: OrderGroup = { passIds: [passId], addressParams: editAddressParams(passId) };

        const answers: SetOrdersData[] =
            selctedTab === TABS.AUTO
                ? [(await sendAutoOrders(group)).data]
                : Object.values((await sendManualOrders(group)).groupResponses)
                      .filter((res): res is AxiosResponse<SetOrdersData> => !!res)
                      .map((res) => res.data);

        const failed = answers.find((answer) => +answer.response !== SUCCESS);
        return { ok: !failed, error: failed ? getSetOrdersErrorMessage(failed) : undefined };
    };

    /** The passenger's orders on the server, over the days the edit touches (the save answer does not list them) */
    const readPassengerOrders = async (passId: string): Promise<SavedOrder[]> => {
        const { proxyUrl, dbUrl = '' } = selectedFcAccount || {};
        const res = await getPassngerShifts({
            proxyUrl,
            dbUrl,
            token,
            ...editData.readRange(editDate, placement.dates),
            clientCode: +selectedClient.value,
            passengers: passId,
        });
        if (+res.data?.response !== SUCCESS) throw new Error('Orders not read');
        return editData.ordersFromPassengersAnswer(res.data, passId);
    };

    /** Rollback: saves one old order again, on its day, at its time, with its own address */
    const recreateOrder = async (passId: string, order: SavedOrder): Promise<boolean> => {
        const { proxyUrl, dbUrl = '' } = selectedFcAccount || {};
        const shiftId = editData.shiftIdForOrder(
            order,
            shifts,
            selctedTab === TABS.AUTO ? placement.autoOrder.shiftId : currOrders.pickup.id || currOrders.drop.id
        );
        if (!shiftId) return false;
        const address = { city: order.city || '', street: order.street || '', houseNum: order.houseNum || '' };
        const res = await setPassengersOrders({
            proxyUrl,
            dbUrl,
            jsonData: {
                token,
                passengers: passId,
                dates: [{ relativeDate: order.date }],
                ...(order.side === 'pickup' ? { pickupTime: order.shiftTime } : { dropTime: order.shiftTime }),
                shiftId,
            },
            ...buildAddresseesParams({
                pickup: order.side === 'pickup' ? (address as Parameters<typeof buildAddresseesParams>[0]['pickup']) : null,
                drop: order.side === 'drop' ? (address as Parameters<typeof buildAddresseesParams>[0]['drop']) : null,
            }),
            clientCode: selectedClient.value,
        });
        return +res.data.response === SUCCESS;
    };

    const deletePassengerOrders = async (passId: string, orders: SavedOrder[]): Promise<boolean> => {
        if (!orders.length) return true;
        if (!selectedFcAccount || !clientCode) return false;

        const res = await delPassngerShifts({
            dbUrl: selectedFcAccount.dbUrl,
            proxyUrl: selectedFcAccount?.proxyUrl,
            orders: orders.map((o) => o.orderCode).join(','),
            relative_date: orders[0].date,
            pass_id: passId,
            token,
            ...editData.timesOf(orders),
            clientCode,
        });
        return +res.data.response === SUCCESS;
    };

    /** Reports the transaction: all saved closes as a save always did; anything else names each passenger */
    const handleEditOutcomes = (outcomes: EditOutcome[]) => {
        const idsWith = (status: EditOutcome['status']) =>
            outcomes.filter((o) => o.status === status).map((o) => o.passId);
        const saved = idsWith('saved');
        const inconsistent = idsWith('inconsistent');

        if (saved.length === outcomes.length) {
            handleResponse({ response: SUCCESS, message: [] as IPassengerShiftUpdate[] } as SetOrdersData);
            return;
        }

        const restoredText = outcomes
            .filter((o) => o.status === 'restored')
            .map((o) => `${getPassengersNames([o.passId])} (${o.error})`)
            .join('; ');

        // Anything but a full save: report each passenger, then close and reload the table. Retrying in this
        // form is not safe - the edited cell (address, codes) belongs to one passenger, and the table data is
        // older than the server now.
        dispatchErrorMsg(
            inconsistent.length
                ? t('editTxInconsistent', {
                      names: getPassengersNames(inconsistent),
                      saved: getPassengersNames(saved) || '-',
                      restored: restoredText || '-',
                      skipped: getPassengersNames(idsWith('skipped')) || '-',
                  })
                : t('editTxPartial', { saved: getPassengersNames(saved) || '-', restored: restoredText })
        );
        dispatch(setEditShift(null));
        onClikClose(handleClose);
    };

    const onSubmitEdit = async () => {
        try {
            // Checked before anything is sent: without them the deletes would "fail" after the saves
            if (!selectedFcAccount || !clientCode) {
                setErrorState({ message: t('genralError'), isShow: true, severity: 'error' });
                return;
            }
            setTempDisabled(true);
            const passIds = selectedPassengers.map((p) => p[PASSENGER_ID_INDEX]);

            const outcomes = await editTransaction.runEditTransaction(
                passIds,
                {
                    readOrders: readPassengerOrders,
                    isReplaced: editData.isOfEditedShift(editDate, replacedTimes),
                    targetSlots: editTargetSlots(),
                    save: saveEditedPassenger,
                    recreate: recreateOrder,
                    remove: deletePassengerOrders,
                },
                {
                    saveFailed: t('genralError'),
                    deleteFailed: t('editTxDeleteFailed'),
                    notSaved: t('editTxNotSaved'),
                    readFailed: t('editTxReadFailed'),
                },
                passIds.length > 1 ? reportGroupsProgress : undefined
            );
            handleEditOutcomes(outcomes);
        } catch (error) {
            console.error(error);
            setErrorState({ message: t('genralError'), isShow: true, severity: 'error' });
        }
    };

    // Not called since the edit transaction (2026-11-02): it deleted the old order BEFORE saving the new one, so a
    // failed save lost the passenger's order. Kept for reference until the transaction has run in production.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const deleteOldOrder = async () => {
        console.log('      deleteOldOrder');

        const { codes = [], passId = '' } = editingShift || {};
        const orderToDelete = changedOrderData.deletedOrder;

        if (!orderToDelete) return;

        if (selectedFcAccount && clientCode) {
            const reqPayload = {
                dbUrl: selectedFcAccount.dbUrl,
                proxyUrl: selectedFcAccount?.proxyUrl,
                orders: [orderToDelete.pickupCode, orderToDelete.dropCode].join(','),
                relative_date: moment(date).format('YYYY-MM-DD'),
                pass_id: passId,
                token,
                pickupTime: orderToDelete.pickupTime,
                dropTime: orderToDelete.dropTime,
                clientCode,
            };

            try {
                const {
                    data: { response },
                } = await delPassngerShifts(reqPayload);

                if (+response === SUCCESS) {
                    if (!editShift)
                        dispatch(
                            removePassengersShift({
                                passId,
                                orderCodes: codes,
                            })
                        );
                    return 0;
                }

                const errorMessage =
                    manualOrdersApiConsts.EDIT_DEL_ORDERS_REQ_ERROR_STINGS[response] ||
                    t('oopsSomethingWentWrongTryAgain');

                dispatchErrorMsg(errorMessage);
            } catch (error) {
                console.log(error);
                dispatchErrorMsg(`ERROR - ${t('oopsSomethingWentWrongTryAgain')}`);
            }
            return -1;
        }
    };

    const onSubmit = async () => {
        console.log('   onSubmit  selctedTab  ', selctedTab);

        // Editing: the transaction saves first and deletes after (2026-11-02). It replaced deleting first:
        // let deleteSuccess = true;
        // if (editingShift) {
        //     deleteSuccess = (await deleteOldOrder()) === 0;
        // }
        // if (!deleteSuccess) return;

        setIsSubmitting(true);
        if (selectedPassengers.length > 1) {
            setSaveProgress({ done: 0, current: 0, total: selectedPassengers.length });
        }
        try {
            if (editingShift) await onSubmitEdit();
            else if (selctedTab === TABS.AUTO) await onSubmitAuto();
            else if (selctedTab === TABS.MANUAL) await onSubmitManual();
        } finally {
            setSaveProgress(null);
            setIsSubmitting(false);
        }
    };

    const handleCloseAlert = () => setErrorState((pre) => ({ ...pre, isShow: false }));

    // & utils
    const disabledSubmit = useIsSubmitDisabled(selctedTab, selectedPassengersFullData);

    const getPassengersDetails = useCallback(() => {
        if (selectedPassengers.length === 1) {
            try {
                const idx = selectedPassengers[0][PASSENGER_LOCATION_INDEX];
                return passengers[idx]?.fullName;
            } catch (err) {
                console.log(err);
                return '';
            }
        }

        return `${selectedPassengers.length} ${t('passengers')}`;
    }, [passengers, selectedPassengers, t]);

    // & Effects

    const isInShortFormat = (dateStr: string): boolean => dateStr.length === 8;

    useEffect(() => {
        if (!relativeDateOfCurrShiftCell) return;
        // console.log(523);

        setPlacment((place) => ({
            ...place,
            dates: [
                {
                    relativeDate: stringifyDate(
                        relativeDateOfCurrShiftCell,
                        RELATIVE,
                        isInShortFormat(relativeDateOfCurrShiftCell) ? SHORT : RELATIVE
                    ),
                },
            ],
        }));
    }, [relativeDateOfCurrShiftCell, setPlacment]);

    // useEffect(() => {
    //     if (date) setInitalDate(date);
    // }, [date]);

    useEffect(() => {
        if (editShiftRedux) {
            const { pickupTime = '', dropTime = '' } = editShiftRedux;
            // resetPlacement();
            const editedShiftDateRelative = formatDateToString(editShiftRedux.date, RELATIVE);

            if (!selectedManualShift) {
                const { shiftId } = shifts.find((shift) => shift.pickupTime === pickupTime) || {};
                setSelectedTab(TABS.AUTO);
                setPlacment((pre) => ({
                    ...pre,
                    autoOrder: {
                        shiftId: `${shiftId}`,
                        pickupTime,
                        dropTime,
                    },
                    manualOrder: initialManualOrderState,
                    dates: [
                        {
                            relativeDate: editedShiftDateRelative,
                        },
                    ],
                }));
            } else if (selectedManualShift) {
                const { shiftId: pickupShiftId } =
                    shifts.find((shift) => shift.pickupTime === pickupTime) || {};
                const { shiftId: dropShiftId } = shifts.find((shift) => shift.dropTime === dropTime) || {};

                setPlacment((pre) => ({
                    ...pre,
                    autoOrder: initialAutoOrderState,
                    manualOrder: {
                        pickup: {
                            pickupShiftId: pickupTime ? `${pickupShiftId}` : '',
                            pickupTime,
                        },
                        drop: {
                            dropShiftId: dropTime ? `${dropShiftId}` : '',
                            dropTime,
                        },
                    },
                    dates: [
                        {
                            relativeDate: editedShiftDateRelative,
                        },
                    ],
                }));
                setSelectedTab(TABS.MANUAL);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editShift, shifts, setPlacment, editShiftRedux]);

    // & Returned JSX

    return (
        // eslint-disable-next-line react/jsx-boolean-value
        <Slide in unmountOnExit direction="up">
            <Styles.Container
                blockedTableClickCount={countWithDelay}
                className={blockedTableClickCount ? 'container shake' : 'container'}
            >
                {/* TITLE AND TIME */}
                <Styles.Title>
                    {t('placemenTransportation')}
                    <span>{`${t('for')} ${getPassengersDetails()}`}</span>
                </Styles.Title>
                <Styles.Hr />
                {/* Title and footer stay put; on a short screen only this part scrolls */}
                <Styles.ScrollArea>
                {/* The date range moved under the days title, above the days it fills (owner, 2026-11-01) */}
                {/* <DatePickerWithPrevNext {...datePickerProps} /> */}

                {/* Step 1 of 3 - shift, addresses, days: the same order for one passenger and for several */}
                <StepTitle>
                    <StepNumber>1</StepNumber>
                    {t('placementStepShift')}
                </StepTitle>

                {/* TABS */}
                <Styles.StyledTabs
                    value={selctedTab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                >
                    <Tab label={t('regularShiftPlacement')} />
                    <Tab label={t('manualPlacement')} />
                </Styles.StyledTabs>

                {/* SHIFT PICK  */}
                <Styles.TabContainer>
                    {selctedTab === TABS.AUTO && <Regularshiftplacement shifts={shifts} />}
                    {selctedTab === TABS.MANUAL && <ManualPlacement shifts={shifts} />}
                </Styles.TabContainer>

                {/* Several passengers: the addresses summary right after the shift, visible without scrolling */}
                {isMultiPassengers && (
                    <PassengersAddressesPicker
                        passengers={selectedPassengersForAddresses}
                        choices={addressChoices}
                        onChoicesChange={setAddressChoices}
                    />
                )}

                {/* One passenger: the same step, in the same place, with the lists it always had - the passenger's
                    own addresses and the shift's (customer request, 2026-11-02; it used to come after the days) */}
                {!isMultiPassengers && selectedPassengers.length === 1 && (
                    <PickerStyles.Summary aria-labelledby="passenger-addresses-step-title">
                        <PickerStyles.SummaryTitle id="passenger-addresses-step-title">
                            <StepNumber>2</StepNumber>
                            {t('addressesMatrixTitle')}
                        </PickerStyles.SummaryTitle>
                        <PlacementAddressSelection
                            selectedPassengerCode={selectedPassengers[0][0]}
                            selectedTab={selctedTab === TABS.AUTO ? 'auto' : 'manual'}
                            orderAddresses={editedOrderAddresses}
                            containerStyle={{ paddingTop: '4px' }}
                        />
                    </PickerStyles.Summary>
                )}

                {/* MORE DAYS INPUTS */}
                <Styles.DaysContainer>
                    <MoreDays
                        selectedPassengersFullData={selectedPassengersFullData}
                        datesForOrders={datesForOrders}
                        addDayUtils={addDayUtils}
                        rangeSlot={<OrderDatesDetails datesForOrders={datesForOrders} onPickDates={onPickDates} />}
                    // initialDate={initalDate}
                    // relativeInitialDate={relativeDateOfCurrShiftCell}
                    />
                </Styles.DaysContainer>

                {/* Moved up to step 2, above the days (customer request, 2026-11-02):
                {!isMultiPassengers && selectedPassengers.length === 1 && (
                    <PlacementAddressSelection
                        selectedPassengerCode={selectedPassengers[0][0]}
                        selectedTab={selctedTab === TABS.AUTO ? 'auto' : 'manual'}
                        orderAddresses={editedOrderAddresses}
                    />
                )} */}
                </Styles.ScrollArea>
                {/* BTNS */}
                <Styles.Footer>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        style={{ width: '183px', height: '44px' }}
                        onClick={onSubmit}
                        disabled={
                            !!(disabledSubmit || tempDisabled || isSubmitting || !selectedPassengersFullData.length)
                        }
                        loading={tempDisabled || isSubmitting}
                    >
                        {editShiftRedux ? t('update') : t('ok')}
                    </LoadingButton>
                    {/* After a partial save, close through handleClose so the table shows what was saved */}
                    <Button onClick={() => onClikClose(hasPartialSave ? handleClose : undefined)}>{t('cancel')}</Button>
                </Styles.Footer>

                <Alert open={errorState.isShow} onClose={handleCloseAlert} severity={errorState.severity}>
                    {errorState.message}
                </Alert>

                <SaveProgress progress={saveProgress} />
            </Styles.Container>
        </Slide>
    );
};

PlacemenTransportation.displayName = 'PlacemenTransportation';
export default PlacemenTransportation;
// useEffect(() => {
//    const { proxyUrl, dbUrl = '' } = selectedFcAccount || {};
//    const fromDate = moment(initalDate).format('YYYY-MM-DD'); // TODO
//    const toDate = moment(initalDate).format('YYYY-MM-DD'); // TODO

//    getShifts({ proxyUrl, dbUrl, token, fromDate, toDate }).then((res) => {
//       const { data = [] } = res.data;
//       setShifts(data);
//    });
// }, [selectedFcAccount, token, initalDate]);

// // * Closes component if there are no passengers selected
// useEffect(() => {
//    if (!selectedPassengersCount) onClikClose();
// }, [onClikClose, selectedPassengersCount]);

// // * component is mounted or not
// useEffect(() => {
//    isMounted.current = true;
//    return () => {
//       dispatch(onFormShowChange(false));
//       isMounted.current = false;
//    };
// }, [dispatch]);

// // * Closes form when component unmounts
// useEffect(() => {
//    if (!isFirstRender && isMounted.current === false)
//       dispatch(onFormShowChange(false));
// }, [dispatch, isFirstRender, isMounted]);

// useEffect(() => {
//     if (selectedPassengerIds.length > 1 && editShiftRedux) {
//         onClikClose();
//     }
// }, [editShiftRedux, onClikClose, selectedPassengerIds.length]);

// // * Open form when component mounts
// useEffect(() => {
//     // console.log(31531);
//     // if (!isFormOpen && selectedPassengers.length) {
//     //     dispatch(
//     //         onFormShowChange({
//     //             isOpen: true,
//     //             selectedPassengersIds: selectedPassengers.map((psngr) => psngr[PASSENGER_ID_INDEX]),
//     //         })
//     //     );
//     // }
// }, [dispatch, isFormOpen, selectedPassengers]);

// useEffect(() => {
//     if (!selectedPassengers.length) onClikClose(handleClose);
// }, [handleClose, onClikClose, selectedPassengers.length]);
